import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const UPOFIL_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/upofil/logo.png",
        alt: "Uptown Psych Logo",
        style: { width: "150px", height: "100%", isMobile: { width: "100px" } },
      },
    },
    icons: {},
  },
  providerGroupId: [54, 122],
  state: "IL",
  departmentIds: [229],
};
